module.exports = __webpack_public_path__ + "static/media/id-badge.c203f53e.svg";